'use strict';
module.exports = {
    Treebeard: require('./components/treebeard'),
    decorators: require('./components/decorators'),
    animations: require('./themes/animations'),
    theme: require('./themes/default')
};


//////////////////
// WEBPACK FOOTER
// ./~/react-treebeard/lib/index.js
// module id = 821
// module chunks = 0